<template>
  <Header_en_m/>
  <Concept_index_en_m></Concept_index_en_m>
  <Concept_page_en_m></Concept_page_en_m>
  <Footer_en_m></Footer_en_m>
</template>

<script>
import Header_en_m from "@/components/EN_mobile/Header_en_m";
import Concept_index_en_m from "@/components/EN_mobile/concept/Concept_index_en_m";
import Concept_page_en_m from "@/components/EN_mobile/concept/Concept_page_en_m";
import Footer_en_m from "@/components/EN_mobile/Footer_en_m";

export default {
  name: 'Concept_en_m',
  components: {
    Footer_en_m,
    Concept_page_en_m, Concept_index_en_m, Header_en_m, },
}

</script>